import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TaskTypeEdit, TaskTypeForm, TaskType, TaskTypeCreateResponse, TaskTypeDeleteResponse } from '@k12/models';
import { lastValueFrom, Observable } from 'rxjs';
import { SHARED_ENVIRONMENT } from '@k12/environment';

@Injectable({
  providedIn: 'root'
})
export class TaskTypeService {
  private http: HttpClient = inject(HttpClient);
  private sharedEnvironment = inject(SHARED_ENVIRONMENT);
  private apiUrl = this.sharedEnvironment.adminApiUrl;

  public get(id: string): Observable<HttpResponse<TaskType>> {
    return this.http.get<TaskType>(`${this.apiUrl}/tasktypes/${id}`, { observe: 'response' });
  }

  public getAll(): Observable<HttpResponse<TaskType[]>> {
    return this.http.get<TaskType[]>(`${this.apiUrl}/tasktypes`, { observe: 'response' });
  }

  public async createTaskType(tasktype: TaskTypeEdit): Promise<HttpResponse<TaskTypeCreateResponse>> {
    return await lastValueFrom(this.http.post<TaskTypeCreateResponse>(`${this.apiUrl}/tasktypes`, tasktype, { observe: 'response' }));
  }

  public async updateTaskType(tasktype: TaskTypeEdit): Promise<HttpResponse<TaskTypeCreateResponse>> {
    return await lastValueFrom(this.http.put<TaskTypeCreateResponse>(`${this.apiUrl}/tasktypes`, tasktype, { observe: 'response' }));
  }

  public delete(taskTypeId: string): Observable<HttpResponse<TaskTypeDeleteResponse>> {
    return this.http.delete<TaskTypeDeleteResponse>(`${this.apiUrl}/tasktypes/${taskTypeId}`, { observe: 'response' });
  }

  public getFormsByUserType(userType: number): Observable<TaskTypeForm[]> {
    const params = new HttpParams().set('programPartnerTypeId', userType);

    return this.http.get<TaskTypeForm[]>(`${this.apiUrl}/valueList/tasktypeFormList`, { params });
  }

  public getAllTaskTypes(programPartnerTypeId: number | null = null, search: string | null = null, limit: number | null = null): Observable<TaskType[]> {
    let params = new HttpParams();
    if (programPartnerTypeId) {
      params = params.set('programPartnerTypeId', programPartnerTypeId.toString());
    }
    if (search) {
      params = params.set('search', search);
    }
    if (limit) {
      params = params.set('limit', limit.toString());
    }
    return this.http.get<TaskType[]>(`${this.apiUrl}/tasktypes`, { params });
  }
}
